export default "__VITE_ASSET__CkpbKgfk__"